// AUTO-GENERATED by sync-icons — do not edit.
import type { FC, SVGProps } from 'react';
const SvgDocumentIcon: FC<SVGProps<SVGGElement>> = props => (
  <g {...props}>
    <path d="M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8zM6 20V4h7v5h5v11z" />
  </g>
);
export default SvgDocumentIcon;
SvgDocumentIcon.displayName = 'SvgDocumentIcon';
